let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l1Um6")).then(() => parcelRequire('2Zn3T'));